import { HeatmapColumn, HeatmapInfo, HeatmapRow } from '../../design/charts/heatmap';

const getSlicedArray = (columns: HeatmapColumn[] | HeatmapRow[]) => {
  const totalInfoColumn = columns[0];
  const resultArray = [];
  for (let index = 1; index < columns.length; index += 5) {
    const columnSlice = [totalInfoColumn];
    columnSlice.push(...columns.slice(index, index + 5));
    resultArray.push(columnSlice);
  }
  return resultArray;
};

export const getSlicedHeatmapInfo = (dataArray: HeatmapInfo): HeatmapInfo[] => {
  if (dataArray.columns.length <= 6 && dataArray.rows.length <= 6) {
    return [dataArray];
  }

  const slicedColumns = dataArray.columns.length > 6 ? getSlicedArray(dataArray.columns) : [dataArray.columns];
  const slicedRows = dataArray.rows.length > 6 ? getSlicedArray(dataArray.rows) : [dataArray.rows];
  return buildSlicedHeatmapInfo(slicedColumns, slicedRows);
};

const buildSlicedHeatmapInfo = (
  slicedColumns: HeatmapInfo['columns'][],
  slicedRows: HeatmapInfo['rows'][]
): HeatmapInfo[] => {
  const result: HeatmapInfo[] = [];

  slicedRows.forEach(rowSlice => {
    slicedColumns.forEach(columnSlice => {
      result.push(createHeatmapSlice(columnSlice, rowSlice));
    });
  });

  return result;
};

const createHeatmapSlice = (columnsSlice: HeatmapInfo['columns'], tableRows: HeatmapInfo['rows']): HeatmapInfo => {
  const marketNames = columnsSlice.map(({ name }) => name);

  const filteredRows = tableRows.map(row => ({
    ...row,
    cells: row.cells.filter(cell => marketNames.includes(cell.yName)),
  }));

  return {
    columns: columnsSlice,
    rows: filteredRows,
  };
};
